import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'health-board',
  'patient-portal-logging-action',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'ccda',
    'user_documents',
    {
      type: 'payload',
      selector: ['documentUid'],
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/logging-action-req.js